import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UnitSimModel } from '../../shared/models/UnitSimModel';

declare var $: any;
import * as html2canvas from "html2canvas";

@Component({
    selector: 'qr-code-generator',
    templateUrl: 'qr-code-generator.component.html'
})

export class QRCodeGeneratorComponent implements OnInit {

    @Input() unit: UnitSimModel;
    public labelTitle: string;
    public qrData: string;
    public labelList: any[];

    constructor() {
        this.labelList = [
            { text: '4GT', value: '4GT' },
            { text: '4GEN', value: '4GEN' },
            { text: 'IPT', value: 'IPT' },
            { text: '2GT', value: '2GT' },
            { text: '2GEN', value: '2GEN' }
        ];
        this.labelTitle = '4GEN';
    }

    ngOnInit(): void {
        this.qrData = this.unit.UnitId + '|' + this.unit.SimId + '|IMEI:' + this.unit.IMEI + '|SN:' + this.unit.SerialNo;
    }

    public getLabelFontSize(): string {
        let fontSize = 50;
        if (this.labelTitle.length > 4) {
            fontSize = Math.floor(fontSize / (this.labelTitle.length / 4));
        }
        return fontSize.toString() + 'px';
    }

    public getLabelFileName(): string {
        return this.labelTitle + '_' + this.unit.AccountNo + '_' + this.unit.MobileNo + '.png'
    }

    public generateQR(fileName: string): void {
        //console.log('Generating QR CODE');
        //let w = window.open("");
        html2canvas(document.querySelector(".qr-capture")).then((canvas: any) => {
            // get image data and transform mime type to application/octet-stream
            var
                canvasDataUrl = canvas.toDataURL()
                    .replace(/^data:image\/[^;]*/, 'data:application/octet-stream'),
                link = document.createElement('a'); // create an anchor tag

            // set parameters for downloading
            link.setAttribute('href', canvasDataUrl);
            link.setAttribute('target', '_blank');
            link.setAttribute('download', fileName);

            // compat mode for dispatching click on your anchor
            if (document.createEvent) {
                var evtObj = document.createEvent('MouseEvents');
                evtObj.initEvent('click', true, true);
                link.dispatchEvent(evtObj);
            } else if (link.click) {
                link.click();
            }
        });
    }

    public padLeft(text: string, padChar: string, size: number): string {
        return (String(padChar).repeat(size) + text).substr((size * -1), size);
    }

    public getDateStr(): string {
        let date = new Date();
        let months = [' Jan ', ' Feb ', ' Mar ', ' Apr ', ' May ', ' Jun ',
            ' Jul ', ' Aug ', ' Sep ', ' Oct ', ' Nov ', ' Dec '];
        return (date.getDate() + months[date.getMonth()] + date.getFullYear());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/units/qr-code-generator/qr-code-generator.component.ts